import React, {useState, useEffect} from "react";
import {addressAddressDetails, deleteAddress, editAddressStreetZip, flagAddress, getUserList} from "../../services/adminServices";
import moment from "moment";
import CustomLoader from "../../CustomComponents/CustomLoader";
import {Autocomplete, TextField, CircularProgress, TableSortLabel, Tooltip} from "@mui/material";
import {sweetAlertQuestion, sweetAlerts} from "../../utils/sweet-alerts";
import {Skeleton} from "@mui/material";
import CustomRatingStar from "../../CustomComponents/CustomRatingStar";
import CustomUserName from "../../CustomComponents/CustomUserName";
import CustomIconButton from "../../CustomComponents/CustomIconButton";
import {fDate} from "../../utils/format-time";

import Box from "@mui/material/Box";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Chip from "@mui/material/Chip";
import Badge from "@mui/material/Badge";
import {visuallyHidden} from "@mui/utils";

import {Table, Dropdown} from "antd";

import {getStatusBadge, truncateWords} from "../../utils/format-text";
import CustomPagination from "../../CustomComponents/CustomPagination";
import {useDispatch} from "react-redux";

const ManualAddresses = () => {
	const dispatch = useDispatch();
	const [filterStatus, setFilterStatus] = useState("all");
	const [sortBy, setSortBy] = useState("date-desc");

	const [field, setField] = useState(null);
	const [order, setOrder] = useState(null);

	const [list, setList] = useState([]);
	const [page, setPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);
	const [totalRecode, setTotalRecode] = useState(0);
	const [loading, setLoading] = useState(true);

	const [loadingButtons, setLoadingButtons] = useState({});

	const [showDetailModal, setShowDetailModal] = useState(false);
	const [selectedAddress, setSelectedAddress] = useState(null);

	const getMockAddress = () => {
		setLoading(true);
		addressAddressDetails({
			page: page,
			pagesize: pageSize,
			sortBy: sortBy,
			status: filterStatus,
			field,
			order,
			manual: "true",
		})
			.then((res) => {
				setLoading(false);
				if (res?.status) {
					setList(res?.data?.list || []);
					setTotalRecode(res?.data?.totalCount || 0);
				}
			})
			.catch(() => {
				setList([]);
				setTotalRecode(0);
			});
	};

	useEffect(() => {
		getMockAddress();
	}, [page, pageSize]);

	useEffect(() => {
		dispatch({type: "SET_PAGE_TITLE", payload: "Addresses"});
	}, []);

	useEffect(() => {
		setPage(1);
		getMockAddress();
	}, [filterStatus, field, order]);

	const handleDeleteAddress = async (addressId) => {
		sweetAlertQuestion("Are you sure you want to delete this address? This action cannot be undone.").then(async (result) => {
			if (result === "Yes") {
				try {
					await new Promise((resolve) => setTimeout(resolve, 500));
					const response = await deleteAddress(addressId);
					if (response && response.status === true) {
						sweetAlerts("success", "Address deleted successfully");
						getMockAddress();
					} else {
						sweetAlerts("error", "Failed deleting rating. Please try again.");
					}
				} catch (error) {
					console.error("Error deleting address:", error);
					sweetAlerts("error", "Failed deleting address. Please try again.");
				} finally {
				}
			}
		});
	};

	const handleFlagged = async (addressId) => {
		setLoadingButtons((prev) => ({...prev, [`flag-${addressId}`]: true}));
		try {
			const response = await flagAddress({
				id: addressId,
			});

			if (response && response.status === true) {
				getMockAddress();
			} else {
				sweetAlerts("error", "Failed flagging address. Please try again.");
			}
		} catch (error) {
			sweetAlerts("error", "Error flagging address. Please try again.");
		} finally {
			setLoadingButtons((prev) => ({...prev, [`flag-${addressId}`]: false}));
		}
	};

	const columns = [
		{
			title: "Address",
			dataIndex: "address",
			key: "address",
			width: "250px",
			sorter: true,
			ellipsis: {showTitle: false},
			render: (_, item) => (
				<Tooltip title={item?.full_address} arrow>
					{truncateWords(item?.full_address, 30) || "-"}
				</Tooltip>
			),
		},
		{
			title: "User Name",
			dataIndex: "user_name",
			key: "user_name",
			width: "250px",
			sorter: true,
			render: (_, item) => <CustomUserName user={item?.user} />,
		},
		{
			title: "Rating",
			dataIndex: "rating",
			key: "rating",
			width: "180px",
			// sorter: true,
			render: (_, item) => <CustomRatingStar star={item?.aggregate_rating} />,
		},
		{
			title: "Submitted",
			dataIndex: "submitted",
			key: "submitted",
			width: "180px",
			align: "center",
			sorter: true,
			render: (_, item) => fDate(item?.createdAt),
		},
		{
			title: "Total Rating/Comment",
			dataIndex: "rating_comment",
			key: "rating_comment",
			width: "180px",
			render: (_, item) => <>{item?.rating_count + "/" + item?.comment_count}</>,
		},
		{
			title: "Action",
			dataIndex: "Action",
			key: "Action",
			width: "100px",
			fixed: "right",
			align: "right",
			render: (_, item) => (
				<div className="table-actions mb-0 justify-content-end flex-row">
					<button
						className="btn-icon"
						onClick={(e) => {
							e.stopPropagation();
							handleFlagged(item.addresses_id);
						}}
						title="Flag Rating">
						<CustomIconButton type="flag" />
					</button>
					<button
						className="btn-icon"
						title="View Details"
						onClick={(e) => {
							e.stopPropagation();
							setSelectedAddress(item);
							setShowDetailModal(true);
						}}>
						<CustomIconButton type="view" />
					</button>
					<button
						className="btn-icon btn-delete"
						title="Delete Address"
						onClick={(e) => {
							e.stopPropagation();
							handleDeleteAddress(item.addresses_id);
						}}>
						<CustomIconButton type="delete" />
					</button>
				</div>
			),
		},
	];

	return (
		<div className="">
			<div className="page-header">
				<h2>Manual Address</h2>
				<p>View and manage all submitted Manual address ({totalRecode} total)</p>
			</div>
			<div className="ratings-controls ">
				<div className="d-flex justify-content-between" style={{alignItems: "end"}}>
					<div className="d-flex">
						<div className="filter-section">
							<select className="filter-select" value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
								<option value="all">All Status</option>
								<option value="fresh">Fresh Address</option>
								<option value="historic">Historic Address</option>
								<option value="flagged">Flagged Address</option>
							</select>
						</div>
					</div>
					{/* <h5 style={{fontSize: 20, fontWeight: 700}}>Total Address : {totalRecode} </h5> */}
				</div>
			</div>

			<div className="card">
				<Paper sx={{width: "100%", overflow: "hidden"}}>
					<Table
						// size="small"
						columns={columns}
						dataSource={list}
						pagination={false}
						showSorterTooltip={false}
						rowClassName={(record) => (record?.admin_flagged ? "row-flagged" : "")}
						scroll={{x: "max-content"}}
						style={{width: "100%", cursor: "pointer"}}
						onRow={(record) => ({
							onClick: () => {
								setSelectedAddress(record);
								setShowDetailModal(true);
							},
						})}
						onChange={(_, __, sorter) => {
							if (sorter?.field && sorter?.order) {
								setField(sorter?.field);
								setOrder(sorter?.order);
								setOrder(sorter?.order);
							} else {
								setField(null);
								setOrder(null);
							}
						}}
					/>

					{!loading && (
						<CustomPagination
							current={page}
							pageSize={pageSize}
							total={totalRecode}
							onChange={(e) => setPage(e)}
							scroll={{x: "max-content", y: 10 * 5}}
							onShowSizeChange={(p, e) => {
								setPage(p);
								setPageSize(e);
							}}
						/>
					)}
				</Paper>
			</div>

			{showDetailModal && selectedAddress && (
				<div className="modal-overlay" onClick={() => setShowDetailModal(false)}>
					<div className="modal-content" onClick={(e) => e.stopPropagation()}>
						<div className="modal-header">
							<h3>Address Details</h3>
							<button className="modal-close" onClick={() => setShowDetailModal(false)}>
								×
							</button>
						</div>

						<div className="modal-body">
							<div className="detail-section">
								<h4>Address Information</h4>
								<div className="detail-grid">
									<div className="detail-item">
										<span className="detail-label">Address:</span>
										<span className="detail-value">{selectedAddress.full_address}</span>
									</div>
									<div className="detail-item">
										<span className="detail-label">Address Date:</span>
										<span className="detail-value">
											{fDate(selectedAddress?.createdAt)}
											{/* <span className="days-ago"> ({selectedAddress.daysAgo} days ago)</span> */}
										</span>
									</div>
									<div className="detail-item">
										<span className="detail-label">Overall Rating:</span>
										<span className="detail-value d-flex align-items-center gap-2">
											<div className="stars">
												<CustomRatingStar star={selectedAddress?.aggregate_rating} />
											</div>
										</span>
									</div>
								</div>
							</div>
						</div>

						<div className="modal-footer">
							<button className="btn btn-secondary" onClick={() => setShowDetailModal(false)}>
								Close
							</button>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default ManualAddresses;
